import { memo, useRef } from 'react';
import FloatAnimation from './FloatAnimation';
import RainAnimation from './RainAnimation';

interface IconProps {
  className?: string;
}

function SleetIcon({ className }: IconProps) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  return (
    <svg
      ref={svgRef}
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-test="weather-icon-sleet"
    >
      <path
        d="M55.0684 22C67.2823 22 77.1836 31.9013 77.1836 44.1152C77.1836 44.5608 77.1695 45.0033 77.1436 45.4424H84.3457C93.6283 45.4424 101.154 52.9674 101.154 62.25C101.154 71.5325 93.6282 79.0576 84.3457 79.0576H34.8076C25.5251 79.0576 18.0002 71.5325 18 62.25C18 53.5784 24.5669 46.4402 32.999 45.5381C32.9691 45.0676 32.9531 44.5932 32.9531 44.1152C32.9531 31.9012 42.8544 22 55.0684 22Z"
        fill="white"
        fillOpacity="0.7"
      >
        <FloatAnimation />
      </path>
      <path
        d="M39.6477 76.3516C40.0058 75.6046 40.9017 75.2894 41.6487 75.6475C42.3956 76.0056 42.7108 76.9014 42.3528 77.6484L38.8528 84.9512C38.4947 85.6981 37.5988 86.0133 36.8518 85.6553C36.1049 85.2972 35.7897 84.4013 36.1477 83.6543L39.6477 76.3516Z"
        fill="white"
      >
        <RainAnimation delay={0} />
      </path>
      <path
        d="M55.1477 76.3516C55.5058 75.6046 56.4017 75.2894 57.1487 75.6475C57.8956 76.0056 58.2108 76.9014 57.8528 77.6484L54.3528 84.9512C53.9947 85.6981 53.0988 86.0133 52.3518 85.6553C51.6049 85.2972 51.2897 84.4013 51.6477 83.6543L55.1477 76.3516Z"
        fill="white"
      >
        <RainAnimation delay={0.3} />
      </path>
      <path
        d="M44.6477 87.3516C45.0058 86.6046 45.9017 86.2894 46.6487 86.6475C47.3956 87.0056 47.7108 87.9014 47.3528 88.6484L43.8528 95.9512C43.4947 96.6981 42.5988 97.0133 41.8518 96.6553C41.1049 96.2972 40.7897 95.4013 41.1477 94.6543L44.6477 87.3516Z"
        fill="white"
      >
        <RainAnimation delay={0.6} />
      </path>
      <path
        d="M65.1475 84C65.9759 84 66.6475 84.6716 66.6475 85.5V88.1611L68.9727 86.8193C69.69 86.4053 70.6073 86.6509 71.0215 87.3682C71.4357 88.0855 71.19 89.0027 70.4727 89.417L68.168 90.7471L70.4746 92.0791C71.1919 92.4934 71.4376 93.4106 71.0234 94.1279C70.6092 94.8453 69.692 95.0909 68.9746 94.6768L66.6475 93.333V96.0195C66.6474 96.8479 65.9758 97.5195 65.1475 97.5195C64.3191 97.5195 63.6476 96.8479 63.6475 96.0195V93.3574L61.3623 94.6768C60.6449 95.0909 59.7277 94.8453 59.3135 94.1279C58.8993 93.4106 59.1451 92.4934 59.8623 92.0791L62.1689 90.7471L59.8643 89.417C59.147 89.0027 58.9013 88.0855 59.3154 87.3682C59.7296 86.6508 60.6469 86.4053 61.3643 86.8193L63.6475 88.1367V85.5C63.6475 84.6716 64.3191 84 65.1475 84Z"
        fill="white"
      >
        <RainAnimation duration={1.8} delay={0} moveY={6} />
      </path>
      <path
        d="M78.2598 72C79.0882 72 79.7598 72.6716 79.7598 73.5V76.1611L82.085 74.8193C82.8023 74.4053 83.7196 74.6508 84.1338 75.3682C84.548 76.0855 84.3022 77.0027 83.585 77.417L81.2803 78.7471L83.5869 80.0791C84.3041 80.4934 84.5499 81.4106 84.1357 82.1279C83.7215 82.8453 82.8043 83.0909 82.0869 82.6768L79.7598 81.333V84.0195C79.7597 84.8479 79.0881 85.5195 78.2598 85.5195C77.4314 85.5195 76.7599 84.8479 76.7598 84.0195V81.3574L74.4746 82.6768C73.7572 83.0909 72.84 82.8453 72.4258 82.1279C72.0116 81.4106 72.2573 80.4934 72.9746 80.0791L75.2812 78.7471L72.9766 77.417C72.2593 77.0027 72.0136 76.0855 72.4277 75.3682C72.8419 74.6509 73.7592 74.4053 74.4766 74.8193L76.7598 76.1367V73.5C76.7598 72.6716 77.4313 72 78.2598 72Z"
        fill="white"
      >
        <RainAnimation duration={1.8} delay={0.5} moveY={6} />
      </path>
    </svg>
  );
}

export default memo(SleetIcon);
